import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import CrossIcon from '@src/assets/icons/cross.svg';
import InstagramIcon from '@src/assets/icons/instagram.svg';
import PlusIcon from '@src/assets/icons/plus.svg';
import { useEffect, useState } from 'react';
import * as Sc from "../../../../button/Button.styled";
import { MEDIA_TYPES, PostPicker } from "../../../../postPicker";
import { BodyCaption, BodyPrimary, BodySecondary, } from "../../../../TypographyStyle";
import { unCamelCase } from "../../../../../utils/unCamelCase";
import { PRIMARY } from "../../../../../constants/colors";
import { COLORS } from "../../../../../constants/Theme";
const IgPicker = (props) => {
    var _a, _b, _c;
    const [showModal, setShowModal] = useState(false);
    const [selectedMedia, setSelectedMedia] = useState([]);
    const [allMedia, setAllMedia] = useState([]);
    const [error, setError] = useState(false);
    useEffect(() => {
        if (props.errors && props.errors.val) {
            setError(true);
        }
    }, [(_a = props.errors) === null || _a === void 0 ? void 0 : _a.val]);
    useEffect(() => {
        var _a;
        if (props.val && ((_a = props.val) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            setSelectedMedia(props.val);
        }
    }, [(_b = props.val) === null || _b === void 0 ? void 0 : _b.length]);
    useEffect(() => {
        var _a, _b, _c, _d, _e;
        if (((_a = props === null || props === void 0 ? void 0 : props.extra) === null || _a === void 0 ? void 0 : _a.originalData) && ((_c = (_b = props === null || props === void 0 ? void 0 : props.extra) === null || _b === void 0 ? void 0 : _b.originalData) === null || _c === void 0 ? void 0 : _c.length) > 0) {
            const formattedData = (_e = (_d = props === null || props === void 0 ? void 0 : props.extra) === null || _d === void 0 ? void 0 : _d.originalData) === null || _e === void 0 ? void 0 : _e.map((item) => {
                return {
                    id: item.id,
                    imageUrl: item.media_type === 'VIDEO' ? item.thumbnail_url : item.media_url,
                    redirectionUrl: item.permalink,
                    overlayCaption: `posted on: ${formatTimestamp(item.timestamp)}`,
                };
            });
            setAllMedia(formattedData);
        }
    }, [(_c = props === null || props === void 0 ? void 0 : props.extra) === null || _c === void 0 ? void 0 : _c.originalData]);
    const formatTimestamp = (date) => {
        const inputDate = new Date(date);
        const month = inputDate.getMonth() + 1;
        const day = inputDate.getDate();
        const year = inputDate.getFullYear();
        return `${day}/${month}/${year}`;
    };
    const handleSelection = (selection) => {
        var _a;
        setSelectedMedia(selection);
        setShowModal(false);
        (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, selection);
    };
    const handlePostPicker = () => {
        setShowModal(true);
    };
    const handlePickerClose = () => {
        setShowModal(false);
    };
    const handleDeleteSelection = (id) => {
        var _a, _b;
        const currentlySelected = [...selectedMedia];
        const updatedMedia = currentlySelected.filter((media) => media.id !== id);
        setSelectedMedia(updatedMedia);
        if (updatedMedia.length > 0) {
            (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, updatedMedia);
        }
        else {
            (_b = props.onChange) === null || _b === void 0 ? void 0 : _b.call(props, undefined);
        }
    };
    const generateTitle = (mediaType) => {
        if (mediaType === MEDIA_TYPES.POST || mediaType === MEDIA_TYPES.REEL) {
            return `Select upto 10 ${props.mediaType}s`;
        }
        else {
            return `Select upto 10 stories`;
        }
    };
    return (_jsxs(IgPickerStyled, Object.assign({ mediaType: props.mediaType }, { children: [_jsx("div", Object.assign({ style: { padding: 12 } }, { children: _jsxs("button", Object.assign({ className: `${error ? 'add-media-btn error' : 'add-media-btn'}`, onClick: () => handlePostPicker() }, { children: [_jsx(Sc.ButtonCustomDashedBorder, {}), _jsx(PlusIcon, { color: error ? COLORS.content.negative : COLORS.content.secondary, width: 20, height: 20, style: { marginBottom: 15 } }), _jsxs(BodySecondary, Object.assign({ style: {
                                color: error ? COLORS.content.negative : COLORS.content.primary,
                            } }, { children: ["Add ", unCamelCase(props.mediaType)] })), _jsx("div", { className: "overlay-container" })] })) })), _jsx("div", Object.assign({ className: "product-card-container" }, { children: (selectedMedia === null || selectedMedia === void 0 ? void 0 : selectedMedia.length) > 0 &&
                    selectedMedia.map((media) => {
                        return (_jsx("div", Object.assign({ style: { padding: '7px' } }, { children: _jsxs(ProductCard, Object.assign({ mediaType: props.mediaType }, { children: [_jsx("img", { src: media.imageUrl, alt: media.overlayCaption }), _jsxs("div", Object.assign({ className: "overlay" }, { children: [_jsx("a", Object.assign({ target: "_blank", rel: "noreferrer", href: media.redirectionUrl }, { children: _jsxs("div", Object.assign({ className: "overlay__redirection" }, { children: [_jsx(InstagramIcon, { height: 22, width: 22 }), _jsx(BodyPrimary, Object.assign({ color: PRIMARY, style: {
                                                                fontWeight: 500,
                                                            } }, { children: "View" }))] })) })), _jsx("div", Object.assign({ className: "overlay__caption" }, { children: _jsx(BodyCaption, Object.assign({ color: COLORS.content.placeholder }, { children: media.overlayCaption })) }))] })), _jsx("button", Object.assign({ className: "cross-icon", onClick: () => handleDeleteSelection(media.id) }, { children: _jsx(CrossIcon, { width: 12, height: 12, color: COLORS.content.secondary }) }))] })) }), media.id));
                    }) })), showModal && (_jsx(PostPicker, { limit: 10, selected: selectedMedia, onSelect: handleSelection, title: generateTitle(props.mediaType), showModal: showModal, onClose: () => handlePickerClose(), media: allMedia, mediaType: props.mediaType }))] })));
};
const PostIgPicker = (props) => (_jsx(IgPicker, Object.assign({}, props, { mediaType: MEDIA_TYPES.POST })));
const ReelIgPicker = (props) => (_jsx(IgPicker, Object.assign({}, props, { mediaType: MEDIA_TYPES.REEL })));
const StoryIgPicker = (props) => (_jsx(IgPicker, Object.assign({}, props, { mediaType: MEDIA_TYPES.STORY })));
export { PostIgPicker, ReelIgPicker, StoryIgPicker };
const IgPickerStyled = styled.div `
	display: flex;
	flex-direction: row;
	align-items: center;
	flex: 1;
	overflow: hidden;

	.product-card-container {
		display: flex;
		overflow: auto;
		max-width: calc(
			${(props) => props.mediaType == MEDIA_TYPES.POST ? '100% - 172px' : '100% - 132px'}
		);
	}

	.add-media-btn.error {
		.line-top {
			background: repeating-linear-gradient(
				to right,
				${COLORS.content.negative},
				${COLORS.content.negative} 5px,
				transparent 5px,
				transparent 10px
			);
		}
		.line-right {
			background: repeating-linear-gradient(
				to bottom,
				${COLORS.content.negative},
				${COLORS.content.negative} 5px,
				transparent 5px,
				transparent 10px
			);
		}
		.line-bottom {
			background: repeating-linear-gradient(
				to right,
				${COLORS.content.negative},
				${COLORS.content.negative} 5px,
				transparent 5px,
				transparent 10px
			);
		}
		.line-left {
			background: repeating-linear-gradient(
				to bottom,
				${COLORS.content.negative},
				${COLORS.content.negative} 5px,
				transparent 5px,
				transparent 10px
			);
		}
	}

	.add-media-btn {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		border: none;
		cursor: pointer;
		width: ${(props) => (props.mediaType === MEDIA_TYPES.POST ? 148 : 108)}px;
		height: ${(props) => (props.mediaType === MEDIA_TYPES.POST ? 148 : 180)}px;
		position: relative;
		background-color: transparent;
		border-radius: 4px;
		.line-top {
			position: absolute;
			left: 0;
			top: 0;
			height: 1px;
			width: 100%;
			background: repeating-linear-gradient(
				to right,
				#9e9e9e,
				#9e9e9e 5px,
				transparent 5px,
				transparent 10px
			);
		}
		.line-right {
			position: absolute;
			right: 0;
			top: 0;
			width: 1px;
			height: 100%;
			background: repeating-linear-gradient(
				to bottom,
				#9e9e9e,
				#9e9e9e 5px,
				transparent 5px,
				transparent 10px
			);
		}
		.line-bottom {
			position: absolute;
			left: 0;
			bottom: 0;
			height: 1px;
			width: 100%;
			background: repeating-linear-gradient(
				to right,
				#9e9e9e,
				#9e9e9e 5px,
				transparent 5px,
				transparent 10px
			);
		}
		.line-left {
			position: absolute;
			left: 0;
			top: 0;
			width: 1px;
			height: 100%;
			background: repeating-linear-gradient(
				to bottom,
				#9e9e9e,
				#9e9e9e 5px,
				transparent 5px,
				transparent 10px
			);
			.overlay-container {
				display: none;
			}
		}
	}

	.add-media-btn:hover {
		.overlay-container {
			display: block;
			position: absolute;
			padding: 0;
			padding-top: 1px;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background-color: #000000;
			opacity: 0.03;
		}
	}
	.add-media-btn:active {
		background-color: ${COLORS.background.brandLight};

		.line-top,
		.line-bottom {
			background: repeating-linear-gradient(
				to right,
				${COLORS.content.brand},
				${COLORS.content.brand} 5px,
				transparent 5px,
				transparent 10px
			);
		}
		.line-right,
		.line-left {
			background: repeating-linear-gradient(
				to bottom,
				${COLORS.content.brand},
				${COLORS.content.brand} 5px,
				transparent 5px,
				transparent 10px
			);
		}
	}
`;
const ProductCard = styled.div `
	border-radius: 4px;
	border: 1px solid ${COLORS.stroke.primary};
	position: relative;
	height: ${(props) => (props.mediaType === MEDIA_TYPES.POST ? 150 : 182)}px;

	.overlay {
		display: none;
	}

	.overlay__caption {
		text-align: center;
		background: #fafafa;
		padding: 10px 20px;
		height: 40px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-bottom-left-radius: 4px;
		border-bottom-right-radius: 4px;
	}

	.overlay__redirection {
		display: flex;
		justify-content: center;
		gap: 5px;
		padding: 10px;
	}

	img {
		border-radius: 4px;
		object-fit: cover;
		width: ${(props) => (props.mediaType === MEDIA_TYPES.POST ? 148 : 108)}px;
		height: ${(props) => (props.mediaType === MEDIA_TYPES.POST ? 148 : 180)}px;
	}
	.cross-icon {
		position: absolute;
		right: -8px;
		top: -8px;
		width: 20px;
		height: 20px;
		border-radius: 10px;
		border: 1px solid ${COLORS.stroke.primary};
		background-color: ${COLORS.surface.subdued};
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		padding: 0;
	}

	&:hover {
		.overlay {
			top: 0;
			background-color: rgba(255, 255, 255, 0.9);
			border-radius: 4px;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: space-between;
			position: absolute;
			width: ${(props) => (props.mediaType === MEDIA_TYPES.POST ? 148 : 108)}px;
			height: ${(props) => props.mediaType === MEDIA_TYPES.POST ? 148 : 180}px;
			a {
				text-decoration: none;
			}
		}
	}
`;
//# sourceMappingURL=IgPicker.js.map